import { jsx as _jsx } from "react/jsx-runtime";
import { SurveyorJobsPage } from "./SurveyorJobsPage";
export const SurveyorHome = () => {
    return _jsx(SurveyorJobsPage, {});
};
